import ThrownFire from "./emitters/ThrownFire"
import FireEmitter from "./emitters/FireEmitter"
import SmokeEmitter from "./emitters/SmokeEmitter"
export default [
    ThrownFire,
    FireEmitter,
    SmokeEmitter
]